import { MergeContactActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/MergeContactActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { ActionFeatures } from '../ActionFeatures';
import '../Actions.scss';
export class MergeContactActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$translate', '$timeout', '$rootScope', 'UndoRedoService', 'state', 'CurrentApplicationService', '$scope', 'typeOfAction'];
    constructor(close, action, $onStateChanged, $translate, $timeout, $rootScope, UndoRedoService, state, CurrentApplicationService, $scope, typeOfAction) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction);
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.CurrentApplicationService = CurrentApplicationService;
        this.isEditing = false;
        this.translateExtraString = '{{contact.extras.yourKey}}';
        this.init();
    }
    async init() {
        this.$timeout(() => {
            this.contactForm.name.$setDirty();
            this.checkValidInputs();
        });
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
        this.isContactTaxDocumentEnabled = await ActionFeatures.isContactTaxDocumentEnabled();
        this.genderOptions = [
            {
                value: 'male',
                label: this.$translate.instant('builder-tabs-actions.mergeContact.male'),
            },
            {
                value: 'female',
                label: this.$translate.instant('builder-tabs-actions.mergeContact.female'),
            },
        ];
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        this.addEventOnContactGenderField();
    }
    checkValidInputs() {
        if (!this.action.settings.name) {
            this.save();
        }
    }
    onBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.mergeContact.title');
            this.save();
        }
    }
    startEditing() {
        const input = document.getElementById('contact-title');
        if (input) {
            input.focus();
        }
    }
    create() {
        return new MergeContactActionSettings();
    }
    errorOnAdd() {
        console.error('Could not add a new key');
    }
    cleanAndSave() {
        for (const prop in this.action.settings) {
            if (this.action.settings.hasOwnProperty(prop) && this.action.settings[prop] === '') {
                delete this.action.settings[prop];
            }
        }
        this.save();
    }
    addEventOnContactGenderField() {
        document.querySelector('.sidebar-default-form #contact-gender')
            .addEventListener('bdsChange', ({ detail: { value } }) => {
            this.action.settings.gender = value;
            this.cleanAndSave();
        });
    }
}
MergeContactActionController.$inject = ['close', 'action', '$onStateChanged', '$translate', '$timeout', '$rootScope', 'UndoRedoService', 'state', 'CurrentApplicationService', '$scope', 'typeOfAction'];
